import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M12.288 8.156a2.21 2.21 0 0 1-1.508 2.17s-.064.024-.064.062v.517a.649.649 0 0 1-1.298 0v-.517a1.372 1.372 0 0 1 .947-1.29.921.921 0 0 0 .627-.905.948.948 0 0 0-.933-.894.919.919 0 0 0-.826.524.649.649 0 0 1-1.169-.563A2.21 2.21 0 0 1 10.05 6h.015a2.24 2.24 0 0 1 2.223 2.156Zm-1.57 4.684a.652.652 0 1 0-1.304 0 .652.652 0 0 0 1.305 0Z" fill="currentColor" /> <path d="M4.2 5.655C4.2 4.741 4.941 4 5.855 4h8.69c.914 0 1.655.741 1.655 1.655v7.035c0 .914-.74 1.655-1.655 1.655h-2.172L10.2 16l-2.172-1.655H5.855A1.655 1.655 0 0 1 4.2 12.69V5.655Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);